export const buildRowDataFromFile = (fileRows: string[]): React.ReactNode[] => {
  const rowData = [];
  fileRows?.forEach((row) => {
    rowData.push(JSON.parse(row));
  });
  return rowData;
};
